import styled, { css } from "styled-components";
import { colors } from "stylesheets";

export function getColor(selected) {
  return selected ? "primary" : "greyMedium";
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 40px 25px;
`;

export const CheckWrapper = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  background: ${colors.primary};
  width: 30px;
  height: 30px;
  border-radius: 100%;
  position: absolute;
  left: -15px;
  top: -15px;
`;

export const Selector = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 1px solid ${({ selected }) => colors[getColor(selected)]};
  cursor: pointer;
  width: 180px;
  height: 150px;
  position: relative;

  ${({ selected }) =>
    selected &&
    css`
      & ${CheckWrapper} {
        display: flex;
      }
    `}

  & > svg {
    margin-bottom: 30px;
  }

  & p {
    color: ${({ selected }) => colors[getColor(selected)]} !important;

    &:last-of-type {
      font-size: 12px;
    }
  }
`;
